<header class="topbar">
  <div class="topbar__left">
    <button
      class="topbar__hamburger"
      (click)="sidebar.toggleMobile()"
      title="Menu"
    >
      <i class="ri-menu-line"></i>
    </button>
    <nav class="topbar__breadcrumb" *ngIf="breadcrumbs.length">
      <ol>
        <li>
          <a [routerLink]="'/admin'"><i class="ri-home-4-line"></i></a>
        </li>
        @for (
          bc of breadcrumbs;
          track bc.url + "-" + $index;
          let last = $last
        ) {
          <li [class.last]="last">
            <a *ngIf="!last" [routerLink]="bc.url">{{ bc.label }}</a>
            <span *ngIf="last">{{ bc.label }}</span>
          </li>
        }
      </ol>
    </nav>
  </div>

  <div class="topbar__right">
    <button
      class="topbar__icon-btn nav-alert-bell"
      (click)="showAlertsDrawer = true"
      title="Notificações"
      style="position: relative"
    >
      <i class="ri-notification-3-line"></i>
      <span class="bell-badge" *ngIf="alertCount$ | async as count">
        {{ count }}
      </span>
    </button>

    <button
      class="topbar__icon-btn theme-toggle"
      (click)="theme.toggle()"
      [title]="theme.isDark() ? 'Alternar para modo claro' : 'Alternar para modo escuro'"
    >
      <i [class]="theme.isDark() ? 'ri-sun-line' : 'ri-moon-line'"></i>
    </button>

    <div
      class="user-menu"
      clickOutside
      (clickOutside)="userMenuOpen = false"
      (click)="toggleUserMenu()"
    >
      <div class="user-avatar">{{ userInitials }}</div>
      <!-- <span class="user-name">{{ userName }}</span> -->
      <i class="ri-arrow-down-s-line" [class.rotated]="userMenuOpen"></i>

      <div
        class="user-dropdown"
        *ngIf="userMenuOpen"
        (click)="$event.stopPropagation()"
      >
        <div class="dropdown-header">
          <div class="dh-avatar">{{ userInitials }}</div>
          <div>
            <p class="dh-name">{{ userName }}</p>
            <p class="dh-role">{{ userRole }}</p>
          </div>
        </div>
        <div class="dropdown-divider"></div>
        <a
          class="dropdown-item"
          routerLink="/admin/configuracoes"
          (click)="userMenuOpen = false"
        >
          <i class="ri-settings-3-line"></i> Configurações
        </a>
        <div class="dropdown-divider"></div>
        <button class="dropdown-item danger" (click)="logout()">
          <i class="ri-logout-box-r-line"></i> Sair
        </button>
      </div>
    </div>
  </div>
</header>

<p-drawer
  [(visible)]="showAlertsDrawer"
  position="right"
  [modal]="true"
  [blockScroll]="true"
  [style]="{ width: 'min(480px, 100vw)' }"
  styleClass="alerts-center-drawer"
  header="Centro de Alertas"
>
  <div class="drawer-body">
    <p
      class="drawer-subtitle"
      style="
        font-size: 13px;
        color: var(--sp-muted, #7d8590);
        margin-bottom: 16px;
        margin-top: 0;
      "
    >
      Atividade operacional recebida em tempo real pelo grupo PostoComando.
    </p>

    <div class="notification-section-header">
      <div>
        <strong>Notificações</strong>
        <span
          class="connection-state"
          [class.connected]="(connectionState$ | async) === 'connected'"
        >{{ notificationSvc.connectionStateLabel((connectionState$ | async) ?? "disconnected") }}</span>
      </div>
      <button type="button" (click)="marcarTodasComoLidas()">
        Marcar como lidas
      </button>
    </div>

    <div
      class="modal-alerts-list occurrence-alerts"
      *ngIf="notificacoes$ | async as notificacoes"
    >
      <div *ngIf="notificacoes.length === 0" class="empty-alerts compact">
        <i class="ri-notification-off-line"></i>
        <span>Nenhuma notificação recebida.</span>
      </div>

      <button
        type="button"
        *ngFor="let o of notificacoes | slice: 0 : 8"
        class="occurrence-card"
        [class.unread]="!o.lida"
        [class.urgent]="notificationSvc.isUrgent(o)"
        (click)="irParaNotificacao(o)"
      >
        <span class="occurrence-card__icon">
          <i [class]="notificationSvc.icon(o)"></i>
        </span>

        <span class="occurrence-card__content">
          <span class="occurrence-card__topline">
            <span class="occurrence-card__code">{{ notificationSvc.entityCode(o) }}</span>
            <time>{{ o.occurredAt | date: "dd/MM · HH:mm" }}</time>
          </span>

          <strong class="occurrence-card__title">{{ o.title }}</strong>

          <span class="occurrence-card__place">
            <i class="ri-map-pin-2-line"></i>
            {{ notificationSvc.contextLabel(o) }}
          </span>

          <span class="occurrence-card__meta">
            <span class="severity-pill" [class.urgent]="notificationSvc.isUrgent(o)">
              {{ notificationSvc.eventLabel(o.event) }}
            </span>
            <span class="occurrence-card__agent">{{ o.description }}</span>
          </span>
        </span>

        <i class="ri-arrow-right-s-line occurrence-card__arrow"></i>
      </button>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div
      class="drawer-footer-custom"
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 0;
        gap: 8px;
        width: 100%;
      "
    >
      <button class="btn-web-secondary" (click)="showAlertsDrawer = false">
        Fechar
      </button>
      <a
        routerLink="/admin/posto-comando"
        (click)="showAlertsDrawer = false"
        class="btn-web-primary"
        style="text-decoration: none"
      >
        Abrir Posto de Comando
        <i class="fas fa-arrow-right" style="margin-left: 6px"></i>
      </a>
    </div>
  </ng-template>
</p-drawer>
